module.exports = __webpack_public_path__ + "media/logos/logo_conisen_horizontal-blanco-df78e8a1.png";